<template>
    <div :class="{'list-group border-radius-2 no-border': !mini && !inline}">
        <div v-for="programme in programmes" :key="programme.Id" :class="{'p-0': inline, 'pv-2': mini, 'list-group-item': !mini && !inline }">
            <CheckboxInput
                v-if="!inline"
                :value="isSelected(programme)"
                @input="toggleProgramme(programme)"
                :label="programme.Name"
                :class="mini ? 'mb-1' : ''"
            />
            <div class="d-flex flex-row align-items-center flex-wrap">
                <button
                    v-for="year in $config.getProgrammeYears(programme.Id)"
                    :key="year"
                    type="button"
                    class="btn"
                    :class="`mr-${margin} mb-${margin} ${isSelected(programme, year) ? 'btn-primary' : 'btn-outline-secondary'} ${mini ? 'btn-sm' : ''}`"
                    @click="toggleYear(programme, year)"
                >
                    {{ $t('year') }} {{ year }}
                </button>
                <CheckboxInput
                    v-if="inline"
                    :label="programme.Name"
                    :srOnly="true"
                    :value="isSelected(programme)"
                    @input="toggleProgramme(programme)"
                    :class="`mb-${margin} ml-${margin}`"
                />
            </div>
        </div>
    </div>
</template>

<script>
import CheckboxInput from "src/components/Inputs/CheckboxInput.vue"

export default {
    components: {
        CheckboxInput
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        useProgrammes: {
            type: Array,
            default: null,
        },
        // Choose from a handful of default presentation styles for this item
        // "widget": this is the default style
        // "inline": this present without the headings and inline
        // "none": this removes all styles so you can create your own using slots
        selectorStyle: {
            type: String,
            default: 'widget',
        },
        inline: {
            type: Boolean,
            default: false,
        },
        mini: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        this.programmes = this.useProgrammes ? this.useProgrammes : this.$config.getValue('programmes')
    },
    data() {
        return {
            innerValue: this.value,
            programmes: [],
            margin: this.mini ? '1' : '2',
        }
    },
    methods: {
        isSelected(programme, year) {
            if (year) return this.innerValue.findIndex(el => el.programme_id == programme.Id && el.year == year) > -1
            else return this.innerValue.filter(progYear => progYear.programme_id == programme.Id).length == Number(programme.CourseLengthYears)
        },
        toggleProgramme(programme) {
            const selected = this.isSelected(programme)

            this.innerValue = this.innerValue.filter(progYear => progYear.programme_id != programme.Id)
            if (!selected) this.innerValue.push(...this.$config.getProgrammeYears(programme.Id).map(year => { return { programme_id: programme.Id, year }}))

            this.$emit('input', this.innerValue)
        },
        toggleYear(programme, year) {
            if (this.isSelected(programme, year)) this.innerValue = this.innerValue.filter(progYear => !(progYear.programme_id == programme.Id && progYear.year == year))
            else this.innerValue.push({ programme_id: programme.Id, year })

            this.$emit('input', this.innerValue)
        }
    },
    watch: {
        value(newVal) {
            this.innerValue = newVal
        }
    }
}
</script>
